<template>
    <div>

        <!-- 期作簡介 -->
        <div v-if="loading">
            <AgriLoading :showCloud="true" :showAgriGift="true"></AgriLoading>
        </div>
        <div v-else-if="cropperiod_detail">
            <b-row>
                <b-col cols="12" xl="3" md="4" sm="4">
                    <h4 class="card-title agri-color" v-text="cropperiod_detail.name"></h4>
                    <div class="cropperiod-img cover-bg" alt="cropperiods photo" :style="$tools.style.imgCover( $config.checkURL('cropperiod', cropperiod_detail.pic) )" />
                </b-col>
                <b-col cols="12" xl="9" md="8" sm="8">

                    <b-tabs v-model="tabIndex">

                        <!-- 期作資訊 -->
                        <b-tab class="info-tab" active :title="$t('menu.cropping_season_information')">

                            <b-row>
                                <b-col cols="12">
                                    <!-- 品種 -->
                                    <h5 class="card-subtitle mb-3 agri-color-sub">
                                        <i class="fa fa-leaf block-text"></i>
                                        <div class="block-text">{{ cropperiod_detail.cropinfo.crop_name }} {{ cropperiod_detail.cropinfo.cultivar_name }}</div>
                                    </h5>

                                    <!-- 敘述 -->
                                    <div class="card-subtitle mb-2">
                                        <div class="block-text">{{ cropperiod_detail.description }}</div>
                                    </div>

                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col cols="12" xl="4">

                                    <!-- 時區 -->
                                    <div class="card-subtitle mb-2">
                                        <i class="fa fa-clock-o block-text"></i>
                                        <div class="block-text">{{ $t('menu.timezone') }}:</div>
                                        <div class="block-text">{{ cropperiod_detail.project_timezone }}</div>
                                    </div>

                                    <!-- 開始日期 -->
                                    <div class="card-subtitle mb-2">
                                        <i class="fa fa-calendar block-text"></i>
                                        <div class="block-text">{{ $t('menu.planting_day') }}:</div>
                                        <div class="block-text">{{ cropperiod_detail.start_date }}</div>
                                    </div>

                                    <!-- 結束日期 -->
                                    <div class="card-subtitle mb-2" v-if="cropperiod_detail.end_date">
                                        <i class="fa fa-calendar block-text"></i>
                                        <div class="block-text">{{ $t('menu.end_date') }}:</div>
                                        <div class="block-text">{{ cropperiod_detail.end_date }}</div>
                                    </div>
                                    
                                    <!-- 面積 -->
                                    <div class="card-subtitle mb-2">
                                        <div class="block-text">
                                            <UnitConvertorArea :area="cropperiod_detail.area" :density="cropperiod_detail.density" defaultUnit="m2" :timezone="cropperiod_detail.project_timezone"
                                                            pageType="cropperiod" selectorType="dropdown"></UnitConvertorArea>
                                        </div>
                                    </div>

                                    <!-- 田區 -->
                                    <div class="card-subtitle mb-2">
                                        <i class="cui-dashboard block-text"></i>
                                        <div class="block-text">{{ $t('n.field') }}:</div>
                                        <div class="block-text">{{ cropperiod_detail.farm_field }}</div>
                                    </div>

                                </b-col>
                                <b-col cols="12" xl="8">

                                    <!-- 種植天數 -->
                                    <div class="emphasis-block" v-if="cropperiod_detail.start_date">
                                        <div class="emphasis-block-title">{{ $t('menu.days_after_planting') }}</div>
                                        
                                        <div class="emphasis-block-body"> {{ cropperiod_detail.count_plantingDays }} </div>
                                        {{ $t('u.days') }}
                                    </div>

                                    <!-- 生長階段 -->
                                    <div class="emphasis-block" v-if="cropperiod_detail.stage.current_growth_stage">
                                        <div class="emphasis-block-title">{{ $t('menu.current_growth_stage') }}</div>
                                        <div class="emphasis-block-body">{{ cropperiod_detail.stage.current_growth_stage }} {{ cropperiod_detail.stage.current_percentage }}%</div>
                                    </div>

                                </b-col>
                            </b-row>

                        </b-tab>

                        <!-- 感測器資訊 -->
                        <b-tab class="info-tab" :title="$t('menu.device_information')">
                            <h5>
                                {{ $t('menu.devices_in_cropping_season') }}
                                <b-badge class="badge-small">{{ cropperiod_detail.devices.length }}</b-badge>
                            </h5>
                            <div v-for="(device, idx_d) in cropperiod_detail.devices" :key="idx_d" class="device-info">
                                <a class="device-title" @click="$tools.ui.goToID( id_device_chart + device.hashid )">
                                    <i :class="$tools.style.classIcon(device.type, 'block-text')"></i>{{ device.nickname }}<span
                                        class="device-hashid">{{ device.hashid }}</span>
                                </a>

                                <div class="device-sensor" v-if="user_admin && device.sensor_params">
                                    <div v-for="(ds, idx_ds) in device.sensor_params" :key="idx_ds" class="device-sensor-blocks">
                                        {{ $t('sensor.' + ds) }}<div class="device-unit" v-html="$t('sensor.u_' + ds)"></div>
                                    </div>
                                </div>
                                <div class="device-sensor" v-else-if="device.visualization">
                                    <div v-for="(ds, idx_ds) in device.visualization" :key="idx_ds" class="device-sensor-blocks">
                                        {{ $t('sensor.' + ds) }}<div class="device-unit" v-html="$t('sensor.u_' + ds)"></div>
                                    </div>
                                </div>

                                <div class="device-description">{{ device.description }}</div>
                            </div>
                        </b-tab>

                        <!-- Admin 備註 -->
                        <b-tab v-if="user_admin" class="info-tab" :title="$t('menu.admin_note')">
                            
                            <b-alert v-if="cropperiod_detail.note" variant="secondary" show >
                                <div v-html="cropperiod_detail.note" class="block-sm"></div>
                            </b-alert>

                        </b-tab>

                    </b-tabs>


                </b-col>
            </b-row>
            <!--/.row-->
        </div>

    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import AgriLoading from '@/views/components/AgriLoading'
    import UnitConvertorArea from '@/views/components/UnitConvertor_Area'

    export default {
        props: {
            cropperiodID: {
                type: [String,Number],
                required: true,
            }
        },
        components: {
            AgriLoading,
            UnitConvertorArea,
        },
        data () {
            return {
                tabIndex: 0,
                loading: false,
            }
        },
        mounted ()
        {
            this.getCropperiod()
        },
        computed: {
            ...mapState({
                'user_admin': state => state.user.is_admin,
                'cropperiod_detail': state => state.cropperiod.cropperiod,
            }),
        },
        watch: {
            cropperiodID (val, oldVal)
            {
                this.getCropperiod()
            },
        },
        methods: {

            // 取得期作資料
            getCropperiod ()
            {
                this.loading = true
                this.$store.dispatch('cropperiod/getCropperiod', this.cropperiodID)
                    .then(res => {
                        this.loading = false
                    })
                    .catch(err => {
                        this.loading = false
                    })
            },

        },
    }
</script>

<style lang="scss" scoped>

    .info-tab {
        min-height: 150px;
    }

    .device-hashid {
        font-size: 0.7rem;
        margin-left: 5px;
    }

    .device-info {
        margin-bottom: 8px;
    }

    .device-title {
        display: inline-block;
        margin-left: -5px;
        margin-bottom: 5px;
        padding: 3px 12px 3px 8px;
        color: black;
        background-color: #eceaea;
        border-radius: 20px 20px 20px 20px;

        &:hover {
            cursor: pointer;
            color: #5bcfcf !important;
            background-color: #2f353a; //#76ad82;
            text-decoration: none;

            i {
                color: #f1d118;
            }
        }
    }

    .device-sensor {
        display: inline-block;
        margin-left: 20px;
        font-size: 0.85rem;
    }

    .device-sensor-blocks {
        display: inline-block;
        margin-right: 5px;
        margin-bottom: 5px;
        padding: 1px 6px;
        background-color: #f5d38a;
        border-radius: 2px;
    }

    .device-unit {
        display: inline-block;
        margin-left: 5px;
        font-size: 0.7rem;
        color: #1f9270;
    }

    .device-description {
        display: inline-block;
        margin-left: 20px;
    }

</style>